"use client";

import { ArrowTopRightOnSquareIcon, CalendarIcon, MapPinIcon } from "@heroicons/react/24/outline";
import { InfoTooltip } from "@/app/Components/InfoTooltip";
import { buttonClassName } from "@/app/Components/buttonStyles";
import { OperationalResult } from "@/app/Components/OperationalPage";

export type IntramuralGame = {
  id: string;
  sport: string;
  opponent: string;
  date: string;
  time: string;
  location: string;
};

type CampusEventRow = {
  id: string;
  title: string;
  category?: string | null;
  start_time: string;
  location?: string | null;
};

export const INTRAMURAL_REGISTRATION_URL = "https://recreation.rutgers.edu/sports";

export function mapIntramuralGame(event: CampusEventRow): IntramuralGame {
  const date = new Date(event.start_time);
  return {
    id: event.id,
    sport: event.category || "Intramural",
    opponent:
      event.title
        .split(" vs ")
        .map((part) => part.split(" (")[0].trim())
        .join(" vs ") || event.title,
    date: date.toLocaleDateString("en-US", {
      weekday: "long",
      month: "long",
      day: "numeric",
      timeZone: "America/New_York",
    }),
    time: date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      timeZone: "America/New_York",
      timeZoneName: "short",
    }),
    location: event.location || "Location to be announced",
  };
}

export const INTRAMURAL_GAME_FIXTURES: IntramuralGame[] = [
  {
    id: "fixture-intramural-game",
    sport: "Basketball",
    opponent: "Scarlet Scholars vs Livingston Rec",
    date: "Tuesday, September 15",
    time: "7:00 PM EDT",
    location: "College Avenue Gym",
  },
];

/** Rutgers Recreation owns teams and registration. This page lists public events. */
export default function EventsIntramuralPanel({ fixtureGames }: { fixtureGames?: IntramuralGame[] }) {
  return <div className="space-y-3">
    <div className="flex flex-wrap items-center gap-1">
      <a href={INTRAMURAL_REGISTRATION_URL} target="_blank" rel="noopener noreferrer" className={buttonClassName({variant:"quiet",size:"sm"})}>
        Teams &amp; registration <ArrowTopRightOnSquareIcon aria-hidden="true" className="h-4 w-4" />
      </a>
      <InfoTooltip title="Rutgers Recreation" text="Rutgers Recreation provides team registration and game schedules. Scarlet Sync lists public events and does not connect to your personal team schedule." />
    </div>
    {fixtureGames?.map(game => <OperationalResult key={game.id}>
      <div className="min-w-0">
        <h3 className="text-base font-semibold text-content">{game.opponent}</h3>
        <p className="mt-1 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-content-muted">
          <span>{game.sport}</span>
          <span className="inline-flex items-center gap-1"><CalendarIcon aria-hidden="true" className="h-4 w-4" />{game.date} · {game.time}</span>
          <span className="inline-flex items-center gap-1"><MapPinIcon aria-hidden="true" className="h-4 w-4" />{game.location}</span>
        </p>
      </div>
    </OperationalResult>)}
  </div>;
}
